import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

function AdminUsersSearch({ onSearchChange }) {
  const [query, setQuery] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    setQuery(value);
    onSearchChange(value);
  };

  const handleClear = () => {
    setQuery("");
    onSearchChange("");
  };

  return (
    <div className="mt-4 md:mt-8 flex w-full px-4 py-3 rounded-md gap-2 border-0 ring-1 ring-inset ring-gray-300 overflow-hidden placeholder:text-gray-600">
      <FontAwesomeIcon icon={faMagnifyingGlass} />
      <input
        type="text"
        value={query}
        onChange={handleChange}
        placeholder="Search Admin Users..."
        className="w-full outline-none bg-transparent text-gray-600 text-sm"
      />
      {query ? (
        <button
          type="button"
          onClick={handleClear}
          className="text-gray-500 hover:text-gray-700"
          aria-label="Clear search"
        >
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>
      ) : null}
    </div>
  );
}

export default AdminUsersSearch;
